import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Gender } from '@src/app/shared/enums/Gender.enum';

@Injectable({
  providedIn: 'root'
})
export class GenderService {

  constructor(public translate: TranslateService) {}

  getGenderOptions(): { label: string; value: Gender }[] {
    return [
      { label: this.translate.instant('CREATE_CUSTOMER.GENDER_FEMALE'), value: Gender.FEMALE },
      { label: this.translate.instant('CREATE_CUSTOMER.GENDER_MALE'), value: Gender.MALE },
      { label: this.translate.instant('CREATE_CUSTOMER.GENDER_OTHER'), value: Gender.OTHER },
      { label: this.translate.instant('CREATE_CUSTOMER.GENDER_PREFER_NOT_TO_SAY'), value: Gender.PREFER_NOT_TO_SAY }
    ];
  }
}
